module.exports = __webpack_public_path__ + "img/hr-V-R-6-unload-connect-shadow.b3964f2a.png";